import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { employmentStatusOptions } from "../../Dashboard/constants/employment";
import { incomeRangeOptions } from "../../Dashboard/constants/incomeRange";
import { investingObjectiveOptions } from "../../Dashboard/constants/investingObjective";
import { investorTypeOptions } from "../../Dashboard/constants/investorType";
import { AdvisorId, ClientId, Custodian } from "../../Types";
import ValidationError from "../../ZodError";
export const Client = z.object({
    id: ClientId,
    advisorId: AdvisorId,
    defaultCustodian: Custodian,
    registeredOn: z.string().datetime(),
    createdTs: z.string().datetime(),
    modifiedTs: z.string().datetime(),
    rishProfile: z.enum(["Low", "Medium", "High"]).nullish(),
    employmentStatus: z.enum(employmentStatusOptions).nullish(),
    incomeRange: z.enum(incomeRangeOptions).nullish(),
    totalAssets: z.number().nullish(),
    isAccreditedInvestor: z.boolean().nullish(),
    investingObjective: z.enum(investingObjectiveOptions).nullish(),
    investorType: z.enum(investorTypeOptions).nullish(),
    iraOutsideFarther: z.number().nullish(),
});
export const url = (clientId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/entity-data/v1/clients/${clientId}`
    : `https://middleware.uat.farther.com/entity-data/v1/clients/${clientId}`;
export default async function getClient(clientId, config) {
    const { data } = await axios.get(url(clientId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = Client.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "getClient returned unexpected data.";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getClient.js.map